var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 0 30 30",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16c-4.227 0-7.667-3.44-7.667-7.667C5.333 4.107 8.773.667 13 .667s7.667 3.44 7.667 7.666C20.667 12.56 17.227 16 13 16Zm0-13.333a5.679 5.679 0 0 0-5.667 5.666A5.679 5.679 0 0 0 13 14a5.68 5.68 0 0 0 5.667-5.667A5.679 5.679 0 0 0 13 2.667ZM24.453 29.333c-.546 0-1-.453-1-1C23.453 23.733 18.76 20 13 20S2.547 23.733 2.547 28.333c0 .547-.453 1-1 1-.547 0-1-.453-1-1C.547 22.64 6.134 18 13 18c6.867 0 12.453 4.64 12.453 10.333 0 .547-.453 1-1 1Z",
    fill: "currentColor"
  })));
};
export { SvgUser as ReactComponent };